(function () {
    document.addEventListener("DOMContentLoaded", () => {
        document.addEventListener('click', function (event) {
            if (
                !event.target.closest('.site-header__search-block') &&
                !event.target.closest('.site-header__search-icon')
            ) {
                document.querySelectorAll('.site-header__search-block').forEach(function (el) {
                    el.classList.remove('open');
                });
            }
        });

        document.querySelectorAll('.site-header__search-icon').forEach(function (icon) {
            icon.addEventListener('click', function (event) {
                event.stopPropagation();
                document.querySelectorAll('.site-header__search-block').forEach(function (block) {
                    block.classList.toggle('open');
                });
            });
        });

        document.querySelectorAll('.site-header__menu-icon').forEach(function (icon) {
            icon.addEventListener('click', function () {
                // Toggle the menu-open class on the wrapper
                document.querySelectorAll('.site-header__wrapper').forEach(function (wrapper) {
                    wrapper.classList.toggle('menu-open');
                });

                // Remove sub-menu-open class
                document.querySelectorAll('.has-sub-menu').forEach(function (el) {
                    el.classList.remove('sub-menu-open');
                });
            });
        });

        document.querySelectorAll('.site-header .menu-item-has-children > a').forEach(function (el) {
            var spanWrapper = document.createElement('span');
            spanWrapper.className = 'site-header__menu-item-dropdown';

            var innerSpan = document.createElement('span');
            innerSpan.className = 'site-header__menu-item-angel';

            spanWrapper.appendChild(innerSpan);
            el.appendChild(spanWrapper);
        });

        document.addEventListener('click', function (e) {
            if (e.target.closest('.has-sub-menu .site-header__menu-item-dropdown')) {
                if (window.innerWidth < 1280) {
                    e.preventDefault();

                    const dropdown = e.target.closest('.site-header__menu-item-dropdown');
                    const parent = dropdown.closest('.has-sub-menu');
                    const submenu = parent.querySelector('.site-header__sub-menu');

                    if (submenu) {
                        parent.classList.toggle('sub-menu-open');
                    }
                }
            }
        });

    });

    const links = document.querySelectorAll(".blog-single__details a");

    links.forEach(function (link) {
        const textMatch = link.textContent.trim() === "VER OFERTAS";

        if (textMatch) {
            link.classList.add("single-offer-btn");
        }
    });

    document.querySelectorAll('.blog-single__details img:not([alt])').forEach(function (img) {
        const src = img.getAttribute('src');
        if (src) {
            const filename = src.split('/').pop().split('.')[0];
            const alt = filename.replace(/[-_]+/g, ' ').replace(/\d+$/, '').trim();
            img.setAttribute('alt', alt.charAt(0).toUpperCase() + alt.slice(1));
        }
    });
})();

document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 972) {

        const swiperEl = document.querySelector('.sidebar-swiper');
        if (swiperEl) {
            const sidebarSwiper = new Swiper(swiperEl, {
                slidesPerView: 1.2,
                spaceBetween: 16,
                loop: true,
                centeredSlides: false,
                pagination: {
                    el: swiperEl.querySelector('.sidebar-post-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperEl.querySelector('.sidebar-post-button-next'),
                    prevEl: swiperEl.querySelector('.sidebar-post-button-prev'),
                },
            });
        }



        const related_swiper = document.querySelector('.related-blog-swiper');
        if (related_swiper && typeof Swiper !== 'undefined') {
            related_swiper.classList.add('swiper');

            const wrapper = related_swiper.querySelector('.related-blog-swiper-wrapper');
            wrapper && wrapper.classList.add('swiper-wrapper');

            const slides = wrapper.querySelectorAll('.related-blog-swiper-slide');
            slides.forEach(slide => slide.classList.add('swiper-slide'));

            new Swiper(related_swiper, {
                slidesPerView: 1.2,
                spaceBetween: 16,
                loop: true,
                centeredSlides: false,
                pagination: {
                    el: related_swiper.querySelector('.related-post-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: related_swiper.querySelector('.related-post-button-next'),
                    prevEl: related_swiper.querySelector('.related-post-button-prev'),
                },
            });
        }

    }
});

//# sourceMappingURL=blogsadevinta-twentyfive.js.map
